import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import type { TaskInfo } from "./useTaskDetailSubscription";
import { InfoRow } from "./InfoRow";

export function TaskInfoSection(props: { task: TaskInfo }) {
  const { task } = props;
  return (
    <Box mb={3}>
      <Typography variant="h4" gutterBottom>{task.name}</Typography>
      <Table size="small">
        <TableBody>
          <InfoRow label="Фаза" value={task.phase} />
          <InfoRow label="Статус фазы" value={task.phaseStatus} />
          <InfoRow label="Язык" value={task.language} />
          <InfoRow label="Целевой URL" value={task.targetUrl} />
          <InfoRow label="Регион" value={task.region} />
          <InfoRow label="Дата создания" value={new Date(task.createdAt).toLocaleString()} />
          <InfoRow label="Автор" value={task.createdByName} />
          <InfoRow label="Последняя публикация" value={task.lastPublishedAt ? new Date(task.lastPublishedAt).toLocaleString() : "—"} />
        </TableBody>
      </Table>
      {task.comment !== null && (
        <Box sx={{ mt: 2, p: 1.5, bgcolor: "warning.light", borderRadius: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Комментарий</Typography>
          <Typography variant="body2">{task.comment}</Typography>
        </Box>
      )}
    </Box>
  );
}
